// AUTO-GENERATED by scripts/generate-barrel.mjs — do not edit.
// Regenerate with: yarn build:openapi-client
import type { Options } from "./client";
import * as sdk from "./client/sdk.gen";
import type * as T from "./client/types.gen";

export const api = {
  atc: {
    getMany: (options?: Options<T.AtcControllerGetManyData, true>) =>
      sdk.atcControllerGetMany<true>(options).then((r) => r.data),
  },
  audit: {
    getMany: (options?: Options<T.AuditControllerGetManyData, true>) =>
      sdk.auditControllerGetMany<true>(options).then((r) => r.data),
  },
  bank: {
    getMany: (options?: Options<T.BankControllerGetManyData, true>) =>
      sdk.bankControllerGetMany<true>(options).then((r) => r.data),
  },
  bill: {
    create: (options: Options<T.BillControllerCreateData, true>) =>
      sdk.billControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.BillControllerDeleteData, true>) =>
      sdk.billControllerDelete<true>(options).then((r) => r.data),
    get: (options: Options<T.BillControllerGetData, true>) => sdk.billControllerGet<true>(options).then((r) => r.data),
    getPage: (options?: Options<T.BillControllerGetPageData, true>) =>
      sdk.billControllerGetPage<true>(options).then((r) => r.data),
    update: (options: Options<T.BillControllerUpdateData, true>) =>
      sdk.billControllerUpdate<true>(options).then((r) => r.data),
  },
  brand: {
    getMany: (options?: Options<T.BrandControllerGetManyData, true>) =>
      sdk.brandControllerGetMany<true>(options).then((r) => r.data),
  },
  cashRegister: {
    create: (options: Options<T.CashRegisterControllerCreateData, true>) =>
      sdk.cashRegisterControllerCreate<true>(options).then((r) => r.data),
    get: (options?: Options<T.CashRegisterControllerGetData, true>) =>
      sdk.cashRegisterControllerGet<true>(options).then((r) => r.data),
    getCurrentByUserId: (options: Options<T.CashRegisterControllerGetCurrentByUserIdData, true>) =>
      sdk.cashRegisterControllerGetCurrentByUserId<true>(options).then((r) => r.data),
    getMany: (options: Options<T.CashRegisterControllerGetManyData, true>) =>
      sdk.cashRegisterControllerGetMany<true>(options).then((r) => r.data),
    getManyByDate: (options: Options<T.CashRegisterControllerGetManyByDateData, true>) =>
      sdk.cashRegisterControllerGetManyByDate<true>(options).then((r) => r.data),
    getReport: (options: Options<T.CashRegisterControllerGetReportData, true>) =>
      sdk.cashRegisterControllerGetReport<true>(options).then((r) => r.data),
    update: (options: Options<T.CashRegisterControllerUpdateData, true>) =>
      sdk.cashRegisterControllerUpdate<true>(options).then((r) => r.data),
  },
  cashReplenishment: {
    create: (options: Options<T.CashReplenishmentControllerCreateData, true>) =>
      sdk.cashReplenishmentControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.CashReplenishmentControllerDeleteData, true>) =>
      sdk.cashReplenishmentControllerDelete<true>(options).then((r) => r.data),
    get: (options: Options<T.CashReplenishmentControllerGetData, true>) =>
      sdk.cashReplenishmentControllerGet<true>(options).then((r) => r.data),
  },
  cashReplenishmentReason: {
    create: (options: Options<T.CashReplenishmentReasonControllerCreateData, true>) =>
      sdk.cashReplenishmentReasonControllerCreate<true>(options).then((r) => r.data),
    getAll: (options?: Options<T.CashReplenishmentReasonControllerGetAllData, true>) =>
      sdk.cashReplenishmentReasonControllerGetAll<true>(options).then((r) => r.data),
  },
  client: {
    getPage: (options?: Options<T.ClientControllerGetPageData, true>) =>
      sdk.clientControllerGetPage<true>(options).then((r) => r.data),
  },
  company: {
    getAll: (options?: Options<T.CompanyControllerGetAllData, true>) =>
      sdk.companyControllerGetAll<true>(options).then((r) => r.data),
    getMany: (options: Options<T.CompanyControllerGetManyData, true>) =>
      sdk.companyControllerGetMany<true>(options).then((r) => r.data),
  },
  contract: {
    create: (options?: Options<T.ContractControllerCreateData, true>) =>
      sdk.contractControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.ContractControllerDeleteData, true>) =>
      sdk.contractControllerDelete<true>(options).then((r) => r.data),
    deleteFromPolicy: (options: Options<T.ContractControllerDeleteFromPolicyData, true>) =>
      sdk.contractControllerDeleteFromPolicy<true>(options).then((r) => r.data),
    getAffiliated: (options?: Options<T.ContractControllerGetAffiliatedData, true>) =>
      sdk.contractControllerGetAffiliated<true>(options).then((r) => r.data),
    getByCompanyId: (options: Options<T.ContractControllerGetByCompanyIdData, true>) =>
      sdk.contractControllerGetByCompanyId<true>(options).then((r) => r.data),
    getById: (options: Options<T.ContractControllerGetByIdData, true>) =>
      sdk.contractControllerGetById<true>(options).then((r) => r.data),
    update: (options: Options<T.ContractControllerUpdateData, true>) =>
      sdk.contractControllerUpdate<true>(options).then((r) => r.data),
  },
  contractPolicy: {
    create: (options: Options<T.ContractPolicyControllerCreateData, true>) =>
      sdk.contractPolicyControllerCreate<true>(options).then((r) => r.data),
    createFromCompanyContract: (options: Options<T.ContractPolicyControllerCreateFromCompanyContractData, true>) =>
      sdk.contractPolicyControllerCreateFromCompanyContract<true>(options).then((r) => r.data),
    get: (options: Options<T.ContractPolicyControllerGetData, true>) =>
      sdk.contractPolicyControllerGet<true>(options).then((r) => r.data),
    update: (options: Options<T.ContractPolicyControllerUpdateData, true>) =>
      sdk.contractPolicyControllerUpdate<true>(options).then((r) => r.data),
  },
  country: {
    getMany: (options?: Options<T.CountryControllerGetManyData, true>) =>
      sdk.countryControllerGetMany<true>(options).then((r) => r.data),
    getManySections: (options: Options<T.CountryControllerGetManySectionsData, true>) =>
      sdk.countryControllerGetManySections<true>(options).then((r) => r.data),
    getManySuppliers: (options: Options<T.CountryControllerGetManySuppliersData, true>) =>
      sdk.countryControllerGetManySuppliers<true>(options).then((r) => r.data),
  },
  currency: {
    getMany: (options?: Options<T.CurrencyControllerGetManyData, true>) =>
      sdk.currencyControllerGetMany<true>(options).then((r) => r.data),
  },
  delivery: {
    create: (options: Options<T.DeliveryControllerCreateData, true>) =>
      sdk.deliveryControllerCreate<true>(options).then((r) => r.data),
    get: (options: Options<T.DeliveryControllerGetData, true>) =>
      sdk.deliveryControllerGet<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.DeliveryControllerGetManyData, true>) =>
      sdk.deliveryControllerGetMany<true>(options).then((r) => r.data),
    getReportCsv: (options: Options<T.DeliveryControllerGetReportCsvData, true>) =>
      sdk.deliveryControllerGetReportCsv<true>(options).then((r) => r.data),
    update: (options: Options<T.DeliveryControllerUpdateData, true>) =>
      sdk.deliveryControllerUpdate<true>(options).then((r) => r.data),
  },
  disbursement: {
    create: (options: Options<T.DisbursementControllerCreateData, true>) =>
      sdk.disbursementControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.DisbursementControllerDeleteData, true>) =>
      sdk.disbursementControllerDelete<true>(options).then((r) => r.data),
    get: (options: Options<T.DisbursementControllerGetData, true>) =>
      sdk.disbursementControllerGet<true>(options).then((r) => r.data),
  },
  disbursementReason: {
    create: (options: Options<T.DisbursementReasonControllerCreateData, true>) =>
      sdk.disbursementReasonControllerCreate<true>(options).then((r) => r.data),
    getAll: (options?: Options<T.DisbursementReasonControllerGetAllData, true>) =>
      sdk.disbursementReasonControllerGetAll<true>(options).then((r) => r.data),
  },
  expense: {
    create: (options: Options<T.ExpenseControllerCreateData, true>) =>
      sdk.expenseControllerCreate<true>(options).then((r) => r.data),
    getPage: (options?: Options<T.ExpenseControllerGetPageData, true>) =>
      sdk.expenseControllerGetPage<true>(options).then((r) => r.data),
    getSummary: (options?: Options<T.ExpenseControllerGetSummaryData, true>) =>
      sdk.expenseControllerGetSummary<true>(options).then((r) => r.data),
    remove: (options: Options<T.ExpenseControllerRemoveData, true>) =>
      sdk.expenseControllerRemove<true>(options).then((r) => r.data),
    update: (options: Options<T.ExpenseControllerUpdateData, true>) =>
      sdk.expenseControllerUpdate<true>(options).then((r) => r.data),
  },
  form: {
    getMany: (options?: Options<T.FormControllerGetManyData, true>) =>
      sdk.formControllerGetMany<true>(options).then((r) => r.data),
  },
  health: {
    check: (options?: Options<T.HealthControllerCheckData, true>) =>
      sdk.healthControllerCheck<true>(options).then((r) => r.data),
    liveness: (options?: Options<T.HealthControllerLivenessData, true>) =>
      sdk.healthControllerLiveness<true>(options).then((r) => r.data),
  },
  importDelivery: {
    importBl: (options: Options<T.ImportDeliveryControllerImportBlData, true>) =>
      sdk.importDeliveryControllerImportBl<true>(options).then((r) => r.data),
  },
  inn: {
    create: (options: Options<T.InnControllerCreateData, true>) =>
      sdk.innControllerCreate<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.InnControllerGetManyData, true>) =>
      sdk.innControllerGetMany<true>(options).then((r) => r.data),
  },
  inventory: {
    close: (options: Options<T.InventoryControllerCloseData, true>) =>
      sdk.inventoryControllerClose<true>(options).then((r) => r.data),
    create: (options: Options<T.InventoryControllerCreateData, true>) =>
      sdk.inventoryControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.InventoryControllerDeleteData, true>) =>
      sdk.inventoryControllerDelete<true>(options).then((r) => r.data),
    get: (options: Options<T.InventoryControllerGetData, true>) =>
      sdk.inventoryControllerGet<true>(options).then((r) => r.data),
    getInventoryValuationReportData: (
      options: Options<T.InventoryControllerGetInventoryValuationReportDataData, true>,
    ) => sdk.inventoryControllerGetInventoryValuationReportData<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.InventoryControllerGetManyData, true>) =>
      sdk.inventoryControllerGetMany<true>(options).then((r) => r.data),
  },
  jwt: {
    createToken: (options: Options<T.JwtControllerCreateTokenData, true>) =>
      sdk.jwtControllerCreateToken<true>(options).then((r) => r.data),
  },
  meCeF: {
    status: (options?: Options<T.MeCeFControllerStatusData, true>) =>
      sdk.meCeFControllerStatus<true>(options).then((r) => r.data),
    testToken: (options: Options<T.MeCeFControllerTestTokenData, true>) =>
      sdk.meCeFControllerTestToken<true>(options).then((r) => r.data),
  },
  movement: {
    getMovementsPage: (options?: Options<T.MovementControllerGetMovementsPageData, true>) =>
      sdk.movementControllerGetMovementsPage<true>(options).then((r) => r.data),
    getReport: (options?: Options<T.MovementControllerGetReportData, true>) =>
      sdk.movementControllerGetReport<true>(options).then((r) => r.data),
    getReportCsv: (options?: Options<T.MovementControllerGetReportCsvData, true>) =>
      sdk.movementControllerGetReportCsv<true>(options).then((r) => r.data),
    getReportData: (options?: Options<T.MovementControllerGetReportDataData, true>) =>
      sdk.movementControllerGetReportData<true>(options).then((r) => r.data),
  },
  order: {
    get: (options: Options<T.OrderControllerGetData, true>) =>
      sdk.orderControllerGet<true>(options).then((r) => r.data),
    getCsv: (options: Options<T.OrderControllerGetCsvData, true>) =>
      sdk.orderControllerGetCsv<true>(options).then((r) => r.data),
    getExportData: (options: Options<T.OrderControllerGetExportDataData, true>) =>
      sdk.orderControllerGetExportData<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.OrderControllerGetManyData, true>) =>
      sdk.orderControllerGetMany<true>(options).then((r) => r.data),
    getMeditectCsv: (options: Options<T.OrderControllerGetMeditectCsvData, true>) =>
      sdk.orderControllerGetMeditectCsv<true>(options).then((r) => r.data),
    update: (options: Options<T.OrderControllerUpdateData, true>) =>
      sdk.orderControllerUpdate<true>(options).then((r) => r.data),
  },
  orderPreparation: {
    close: (options: Options<T.OrderPreparationControllerCloseData, true>) =>
      sdk.orderPreparationControllerClose<true>(options).then((r) => r.data),
    findRecords: (options: Options<T.OrderPreparationControllerFindRecordsData, true>) =>
      sdk.orderPreparationControllerFindRecords<true>(options).then((r) => r.data),
    getRecordStatByProductIds: (options: Options<T.OrderPreparationControllerGetRecordStatByProductIdsData, true>) =>
      sdk.orderPreparationControllerGetRecordStatByProductIds<true>(options).then((r) => r.data),
  },
  orderRecord: {
    delete: (options: Options<T.OrderRecordControllerDeleteData, true>) =>
      sdk.orderRecordControllerDelete<true>(options).then((r) => r.data),
  },
  organization: {
    create: (options: Options<T.OrganizationControllerCreateData, true>) =>
      sdk.organizationControllerCreate<true>(options).then((r) => r.data),
    get: (options: Options<T.OrganizationControllerGetData, true>) =>
      sdk.organizationControllerGet<true>(options).then((r) => r.data),
    getAll: (options?: Options<T.OrganizationControllerGetAllData, true>) =>
      sdk.organizationControllerGetAll<true>(options).then((r) => r.data),
    getBills: (options: Options<T.OrganizationControllerGetBillsData, true>) =>
      sdk.organizationControllerGetBills<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.OrganizationControllerGetManyData, true>) =>
      sdk.organizationControllerGetMany<true>(options).then((r) => r.data),
    getOutgoing: (options: Options<T.OrganizationControllerGetOutgoingData, true>) =>
      sdk.organizationControllerGetOutgoing<true>(options).then((r) => r.data),
    update: (options: Options<T.OrganizationControllerUpdateData, true>) =>
      sdk.organizationControllerUpdate<true>(options).then((r) => r.data),
  },
  organizationContractPolicy: {
    getMany: (options: Options<T.OrganizationContractPolicyControllerGetManyData, true>) =>
      sdk.organizationContractPolicyControllerGetMany<true>(options).then((r) => r.data),
    getManyByAffiliated: (options: Options<T.OrganizationContractPolicyControllerGetManyByAffiliatedData, true>) =>
      sdk.organizationContractPolicyControllerGetManyByAffiliated<true>(options).then((r) => r.data),
  },
  packaging: {
    getMany: (options?: Options<T.PackagingControllerGetManyData, true>) =>
      sdk.packagingControllerGetMany<true>(options).then((r) => r.data),
  },
  payment: {
    updateDeferredMedata: (options: Options<T.PaymentControllerUpdateDeferredMedataData, true>) =>
      sdk.paymentControllerUpdateDeferredMedata<true>(options).then((r) => r.data),
    updateInsuranceMedata: (options: Options<T.PaymentControllerUpdateInsuranceMedataData, true>) =>
      sdk.paymentControllerUpdateInsuranceMedata<true>(options).then((r) => r.data),
  },
  person: {
    create: (options: Options<T.PersonControllerCreateData, true>) =>
      sdk.personControllerCreate<true>(options).then((r) => r.data),
    createPatientByQuickWay: (options: Options<T.PersonControllerCreatePatientByQuickWayData, true>) =>
      sdk.personControllerCreatePatientByQuickWay<true>(options).then((r) => r.data),
    get: (options: Options<T.PersonControllerGetData, true>) =>
      sdk.personControllerGet<true>(options).then((r) => r.data),
    getAll: (options?: Options<T.PersonControllerGetAllData, true>) =>
      sdk.personControllerGetAll<true>(options).then((r) => r.data),
    getBills: (options: Options<T.PersonControllerGetBillsData, true>) =>
      sdk.personControllerGetBills<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.PersonControllerGetManyData, true>) =>
      sdk.personControllerGetMany<true>(options).then((r) => r.data),
    getOutgoing: (options: Options<T.PersonControllerGetOutgoingData, true>) =>
      sdk.personControllerGetOutgoing<true>(options).then((r) => r.data),
    update: (options: Options<T.PersonControllerUpdateData, true>) =>
      sdk.personControllerUpdate<true>(options).then((r) => r.data),
    updatePatientByQuickWay: (options: Options<T.PersonControllerUpdatePatientByQuickWayData, true>) =>
      sdk.personControllerUpdatePatientByQuickWay<true>(options).then((r) => r.data),
  },
  personContractPolicy: {
    getMany: (options: Options<T.PersonContractPolicyControllerGetManyData, true>) =>
      sdk.personContractPolicyControllerGetMany<true>(options).then((r) => r.data),
  },
  personRelationships: {
    create: (options: Options<T.PersonRelationshipsControllerCreateData, true>) =>
      sdk.personRelationshipsControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.PersonRelationshipsControllerDeleteData, true>) =>
      sdk.personRelationshipsControllerDelete<true>(options).then((r) => r.data),
    getAll: (options: Options<T.PersonRelationshipsControllerGetAllData, true>) =>
      sdk.personRelationshipsControllerGetAll<true>(options).then((r) => r.data),
  },
  pharmacy: {
    create: (options: Options<T.PharmacyControllerCreateData, true>) =>
      sdk.pharmacyControllerCreate<true>(options).then((r) => r.data),
    get: (options: Options<T.PharmacyControllerGetData, true>) =>
      sdk.pharmacyControllerGet<true>(options).then((r) => r.data),
    getMany: (options: Options<T.PharmacyControllerGetManyData, true>) =>
      sdk.pharmacyControllerGetMany<true>(options).then((r) => r.data),
    getPage: (options?: Options<T.PharmacyControllerGetPageData, true>) =>
      sdk.pharmacyControllerGetPage<true>(options).then((r) => r.data),
    getSubscription: (options: Options<T.PharmacyControllerGetSubscriptionData, true>) =>
      sdk.pharmacyControllerGetSubscription<true>(options).then((r) => r.data),
    getUsers: (options: Options<T.PharmacyControllerGetUsersData, true>) =>
      sdk.pharmacyControllerGetUsers<true>(options).then((r) => r.data),
    softDelete: (options: Options<T.PharmacyControllerSoftDeleteData, true>) =>
      sdk.pharmacyControllerSoftDelete<true>(options).then((r) => r.data),
    undoSoftDelete: (options: Options<T.PharmacyControllerUndoSoftDeleteData, true>) =>
      sdk.pharmacyControllerUndoSoftDelete<true>(options).then((r) => r.data),
    update: (options: Options<T.PharmacyControllerUpdateData, true>) =>
      sdk.pharmacyControllerUpdate<true>(options).then((r) => r.data),
    updatePrinterSettings: (options: Options<T.PharmacyControllerUpdatePrinterSettingsData, true>) =>
      sdk.pharmacyControllerUpdatePrinterSettings<true>(options).then((r) => r.data),
  },
  pharmacyProduct: {
    associateProduct: (options: Options<T.PharmacyProductControllerAssociateProductData, true>) =>
      sdk.pharmacyProductControllerAssociateProduct<true>(options).then((r) => r.data),
    batchUpdate: (options: Options<T.PharmacyProductControllerBatchUpdateData, true>) =>
      sdk.pharmacyProductControllerBatchUpdate<true>(options).then((r) => r.data),
    create: (options: Options<T.PharmacyProductControllerCreateData, true>) =>
      sdk.pharmacyProductControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.PharmacyProductControllerDeleteData, true>) =>
      sdk.pharmacyProductControllerDelete<true>(options).then((r) => r.data),
    deleteDepackagingSettings: (options: Options<T.PharmacyProductControllerDeleteDepackagingSettingsData, true>) =>
      sdk.pharmacyProductControllerDeleteDepackagingSettings<true>(options).then((r) => r.data),
    get: (options: Options<T.PharmacyProductControllerGetData, true>) =>
      sdk.pharmacyProductControllerGet<true>(options).then((r) => r.data),
    getAll: (options?: Options<T.PharmacyProductControllerGetAllData, true>) =>
      sdk.pharmacyProductControllerGetAll<true>(options).then((r) => r.data),
    getArchivedProducts: (options: Options<T.PharmacyProductControllerGetArchivedProductsData, true>) =>
      sdk.pharmacyProductControllerGetArchivedProducts<true>(options).then((r) => r.data),
    getByDeliveryRecordId: (options: Options<T.PharmacyProductControllerGetByDeliveryRecordIdData, true>) =>
      sdk.pharmacyProductControllerGetByDeliveryRecordId<true>(options).then((r) => r.data),
    getByIds: (options: Options<T.PharmacyProductControllerGetByIdsData, true>) =>
      sdk.pharmacyProductControllerGetByIds<true>(options).then((r) => r.data),
    getByStockItemId: (options: Options<T.PharmacyProductControllerGetByStockItemIdData, true>) =>
      sdk.pharmacyProductControllerGetByStockItemId<true>(options).then((r) => r.data),
    getCountByStockQuantity: (options?: Options<T.PharmacyProductControllerGetCountByStockQuantityData, true>) =>
      sdk.pharmacyProductControllerGetCountByStockQuantity<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.PharmacyProductControllerGetManyData, true>) =>
      sdk.pharmacyProductControllerGetMany<true>(options).then((r) => r.data),
    getProductStats: (options: Options<T.PharmacyProductControllerGetProductStatsData, true>) =>
      sdk.pharmacyProductControllerGetProductStats<true>(options).then((r) => r.data),
    getStats: (options?: Options<T.PharmacyProductControllerGetStatsData, true>) =>
      sdk.pharmacyProductControllerGetStats<true>(options).then((r) => r.data),
    getSubstituteProducts: (options: Options<T.PharmacyProductControllerGetSubstituteProductsData, true>) =>
      sdk.pharmacyProductControllerGetSubstituteProducts<true>(options).then((r) => r.data),
    taxRateUpdate: (options: Options<T.PharmacyProductControllerTaxRateUpdateData, true>) =>
      sdk.pharmacyProductControllerTaxRateUpdate<true>(options).then((r) => r.data),
    unpack: (options: Options<T.PharmacyProductControllerUnpackData, true>) =>
      sdk.pharmacyProductControllerUnpack<true>(options).then((r) => r.data),
    update: (options: Options<T.PharmacyProductControllerUpdateData, true>) =>
      sdk.pharmacyProductControllerUpdate<true>(options).then((r) => r.data),
    upsertDepackagingSettings: (options: Options<T.PharmacyProductControllerUpsertDepackagingSettingsData, true>) =>
      sdk.pharmacyProductControllerUpsertDepackagingSettings<true>(options).then((r) => r.data),
  },
  pharmacyProductStorage: {
    create: (options: Options<T.PharmacyProductStorageControllerCreateData, true>) =>
      sdk.pharmacyProductStorageControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.PharmacyProductStorageControllerDeleteData, true>) =>
      sdk.pharmacyProductStorageControllerDelete<true>(options).then((r) => r.data),
    getAll: (options?: Options<T.PharmacyProductStorageControllerGetAllData, true>) =>
      sdk.pharmacyProductStorageControllerGetAll<true>(options).then((r) => r.data),
    update: (options: Options<T.PharmacyProductStorageControllerUpdateData, true>) =>
      sdk.pharmacyProductStorageControllerUpdate<true>(options).then((r) => r.data),
  },
  pharmacyScheduler: {
    hardDelete: (options: Options<T.PharmacySchedulerControllerHardDeleteData, true>) =>
      sdk.pharmacySchedulerControllerHardDelete<true>(options).then((r) => r.data),
  },
  printAgent: {
    download: (options: Options<T.PrintAgentControllerDownloadData, true>) =>
      sdk.printAgentControllerDownload<true>(options).then((r) => r.data),
  },
  product: {
    archive: (options: Options<T.ProductControllerArchiveData, true>) =>
      sdk.productControllerArchive<true>(options).then((r) => r.data),
    create: (options: Options<T.ProductControllerCreateData, true>) =>
      sdk.productControllerCreate<true>(options).then((r) => r.data),
    createBatch: (options: Options<T.ProductControllerCreateBatchData, true>) =>
      sdk.productControllerCreateBatch<true>(options).then((r) => r.data),
    delete: (options: Options<T.ProductControllerDeleteData, true>) =>
      sdk.productControllerDelete<true>(options).then((r) => r.data),
    get: (options: Options<T.ProductControllerGetData, true>) =>
      sdk.productControllerGet<true>(options).then((r) => r.data),
    getAllByProductId: (options: Options<T.ProductControllerGetAllByProductIdData, true>) =>
      sdk.productControllerGetAllByProductId<true>(options).then((r) => r.data),
    getArchivedProducts: (options?: Options<T.ProductControllerGetArchivedProductsData, true>) =>
      sdk.productControllerGetArchivedProducts<true>(options).then((r) => r.data),
    getByLabelWithHealthInsurance: (options?: Options<T.ProductControllerGetByLabelWithHealthInsuranceData, true>) =>
      sdk.productControllerGetByLabelWithHealthInsurance<true>(options).then((r) => r.data),
    getByWholesalerProductLabel: (options?: Options<T.ProductControllerGetByWholesalerProductLabelData, true>) =>
      sdk.productControllerGetByWholesalerProductLabel<true>(options).then((r) => r.data),
    getFull: (options: Options<T.ProductControllerGetFullData, true>) =>
      sdk.productControllerGetFull<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.ProductControllerGetManyData, true>) =>
      sdk.productControllerGetMany<true>(options).then((r) => r.data),
    getNotice: (options: Options<T.ProductControllerGetNoticeData, true>) =>
      sdk.productControllerGetNotice<true>(options).then((r) => r.data),
    getSpc: (options: Options<T.ProductControllerGetSpcData, true>) =>
      sdk.productControllerGetSpc<true>(options).then((r) => r.data),
    update: (options: Options<T.ProductControllerUpdateData, true>) =>
      sdk.productControllerUpdate<true>(options).then((r) => r.data),
    updateReferential: (options?: Options<T.ProductControllerUpdateReferentialData, true>) =>
      sdk.productControllerUpdateReferential<true>(options).then((r) => r.data),
  },
  productAdvice: {
    populateAdvices: (options: Options<T.ProductAdviceControllerPopulateAdvicesData, true>) =>
      sdk.productAdviceControllerPopulateAdvices<true>(options).then((r) => r.data),
    populateAdvicesByIds: (options: Options<T.ProductAdviceControllerPopulateAdvicesByIdsData, true>) =>
      sdk.productAdviceControllerPopulateAdvicesByIds<true>(options).then((r) => r.data),
    submitFeedback: (options: Options<T.ProductAdviceControllerSubmitFeedbackData, true>) =>
      sdk.productAdviceControllerSubmitFeedback<true>(options).then((r) => r.data),
  },
  productCategory: {
    getAll: (options?: Options<T.ProductCategoryControllerGetAllData, true>) =>
      sdk.productCategoryControllerGetAll<true>(options).then((r) => r.data),
  },
  productHealthInsurance: {
    addProductsFromJson: (options: Options<T.ProductHealthInsuranceControllerAddProductsFromJsonData, true>) =>
      sdk.productHealthInsuranceControllerAddProductsFromJson<true>(options).then((r) => r.data),
    addProductsFromPharmaPlus: (
      options: Options<T.ProductHealthInsuranceControllerAddProductsFromPharmaPlusData, true>,
    ) => sdk.productHealthInsuranceControllerAddProductsFromPharmaPlus<true>(options).then((r) => r.data),
    associateProduct: (options: Options<T.ProductHealthInsuranceControllerAssociateProductData, true>) =>
      sdk.productHealthInsuranceControllerAssociateProduct<true>(options).then((r) => r.data),
    create: (options: Options<T.ProductHealthInsuranceControllerCreateData, true>) =>
      sdk.productHealthInsuranceControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.ProductHealthInsuranceControllerDeleteData, true>) =>
      sdk.productHealthInsuranceControllerDelete<true>(options).then((r) => r.data),
    findAll: (options?: Options<T.ProductHealthInsuranceControllerFindAllData, true>) =>
      sdk.productHealthInsuranceControllerFindAll<true>(options).then((r) => r.data),
    findAllWithAssociatedProduct: (
      options: Options<T.ProductHealthInsuranceControllerFindAllWithAssociatedProductData, true>,
    ) => sdk.productHealthInsuranceControllerFindAllWithAssociatedProduct<true>(options).then((r) => r.data),
    update: (options: Options<T.ProductHealthInsuranceControllerUpdateData, true>) =>
      sdk.productHealthInsuranceControllerUpdate<true>(options).then((r) => r.data),
  },
  productView: {
    create: (options: Options<T.ProductViewControllerCreateData, true>) =>
      sdk.productViewControllerCreate<true>(options).then((r) => r.data),
    getPage: (options?: Options<T.ProductViewControllerGetPageData, true>) =>
      sdk.productViewControllerGetPage<true>(options).then((r) => r.data),
  },
  reports: {
    create: (options: Options<T.ReportsControllerCreateData, true>) =>
      sdk.reportsControllerCreate<true>(options).then((r) => r.data),
  },
  role: {
    create: (options: Options<T.RoleControllerCreateData, true>) =>
      sdk.roleControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.RoleControllerDeleteData, true>) =>
      sdk.roleControllerDelete<true>(options).then((r) => r.data),
    get: (options: Options<T.RoleControllerGetData, true>) => sdk.roleControllerGet<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.RoleControllerGetManyData, true>) =>
      sdk.roleControllerGetMany<true>(options).then((r) => r.data),
    update: (options: Options<T.RoleControllerUpdateData, true>) =>
      sdk.roleControllerUpdate<true>(options).then((r) => r.data),
  },
  sale: {
    create: (options: Options<T.SaleControllerCreateData, true>) =>
      sdk.saleControllerCreate<true>(options).then((r) => r.data),
    createProforma: (options: Options<T.SaleControllerCreateProformaData, true>) =>
      sdk.saleControllerCreateProforma<true>(options).then((r) => r.data),
    delete: (options: Options<T.SaleControllerDeleteData, true>) =>
      sdk.saleControllerDelete<true>(options).then((r) => r.data),
    get: (options: Options<T.SaleControllerGetData, true>) => sdk.saleControllerGet<true>(options).then((r) => r.data),
    getHistory: (options: Options<T.SaleControllerGetHistoryData, true>) =>
      sdk.saleControllerGetHistory<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.SaleControllerGetManyData, true>) =>
      sdk.saleControllerGetMany<true>(options).then((r) => r.data),
    getManyWithVouchers: (options?: Options<T.SaleControllerGetManyWithVouchersData, true>) =>
      sdk.saleControllerGetManyWithVouchers<true>(options).then((r) => r.data),
    normalize: (options: Options<T.SaleControllerNormalizeData, true>) =>
      sdk.saleControllerNormalize<true>(options).then((r) => r.data),
    redeemVoucher: (options: Options<T.SaleControllerRedeemVoucherData, true>) =>
      sdk.saleControllerRedeemVoucher<true>(options).then((r) => r.data),
    refund: (options: Options<T.SaleControllerRefundData, true>) =>
      sdk.saleControllerRefund<true>(options).then((r) => r.data),
    update: (options: Options<T.SaleControllerUpdateData, true>) =>
      sdk.saleControllerUpdate<true>(options).then((r) => r.data),
    updateDate: (options: Options<T.SaleControllerUpdateDateData, true>) =>
      sdk.saleControllerUpdateDate<true>(options).then((r) => r.data),
  },
  saleScheduler: {
    normalizeEmecef: (options?: Options<T.SaleSchedulerControllerNormalizeEmecefData, true>) =>
      sdk.saleSchedulerControllerNormalizeEmecef<true>(options).then((r) => r.data),
  },
  stockExport: {
    createStockExport: (options?: Options<T.StockExportControllerCreateStockExportData, true>) =>
      sdk.stockExportControllerCreateStockExport<true>(options).then((r) => r.data),
    stockExportData: (options?: Options<T.StockExportControllerStockExportDataData, true>) =>
      sdk.stockExportControllerStockExportData<true>(options).then((r) => r.data),
  },
  stockHistory: {
    getStockHistory: (options?: Options<T.StockHistoryControllerGetStockHistoryData, true>) =>
      sdk.stockHistoryControllerGetStockHistory<true>(options).then((r) => r.data),
  },
  stockItem: {
    createDepackagedStockItem: (options: Options<T.StockItemControllerCreateDepackagedStockItemData, true>) =>
      sdk.stockItemControllerCreateDepackagedStockItem<true>(options).then((r) => r.data),
    createStockItem: (options: Options<T.StockItemControllerCreateStockItemData, true>) =>
      sdk.stockItemControllerCreateStockItem<true>(options).then((r) => r.data),
    deleteStockItem: (options: Options<T.StockItemControllerDeleteStockItemData, true>) =>
      sdk.stockItemControllerDeleteStockItem<true>(options).then((r) => r.data),
    restockStockItem: (options: Options<T.StockItemControllerRestockStockItemData, true>) =>
      sdk.stockItemControllerRestockStockItem<true>(options).then((r) => r.data),
    updateStockItem: (options: Options<T.StockItemControllerUpdateStockItemData, true>) =>
      sdk.stockItemControllerUpdateStockItem<true>(options).then((r) => r.data),
    updateStockItemSalePrice: (options: Options<T.StockItemControllerUpdateStockItemSalePriceData, true>) =>
      sdk.stockItemControllerUpdateStockItemSalePrice<true>(options).then((r) => r.data),
  },
  stockScheduler: {
    calculateStockValue: (options?: Options<T.StockSchedulerControllerCalculateStockValueData, true>) =>
      sdk.stockSchedulerControllerCalculateStockValue<true>(options).then((r) => r.data),
  },
  supplier: {
    create: (options: Options<T.SupplierControllerCreateData, true>) =>
      sdk.supplierControllerCreate<true>(options).then((r) => r.data),
    get: (options: Options<T.SupplierControllerGetData, true>) =>
      sdk.supplierControllerGet<true>(options).then((r) => r.data),
    getAll: (options?: Options<T.SupplierControllerGetAllData, true>) =>
      sdk.supplierControllerGetAll<true>(options).then((r) => r.data),
    getPage: (options?: Options<T.SupplierControllerGetPageData, true>) =>
      sdk.supplierControllerGetPage<true>(options).then((r) => r.data),
    update: (options: Options<T.SupplierControllerUpdateData, true>) =>
      sdk.supplierControllerUpdate<true>(options).then((r) => r.data),
  },
  tag: {
    getMany: (options?: Options<T.TagControllerGetManyData, true>) =>
      sdk.tagControllerGetMany<true>(options).then((r) => r.data),
  },
  thresholdSettings: {
    computeThresholds: (options?: Options<T.ThresholdSettingsControllerComputeThresholdsData, true>) =>
      sdk.thresholdSettingsControllerComputeThresholds<true>(options).then((r) => r.data),
    create: (options: Options<T.ThresholdSettingsControllerCreateData, true>) =>
      sdk.thresholdSettingsControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.ThresholdSettingsControllerDeleteData, true>) =>
      sdk.thresholdSettingsControllerDelete<true>(options).then((r) => r.data),
    findAll: (options?: Options<T.ThresholdSettingsControllerFindAllData, true>) =>
      sdk.thresholdSettingsControllerFindAll<true>(options).then((r) => r.data),
    update: (options: Options<T.ThresholdSettingsControllerUpdateData, true>) =>
      sdk.thresholdSettingsControllerUpdate<true>(options).then((r) => r.data),
  },
  thresholdSettingsCloud: {
    computeThresholds: (options?: Options<T.ThresholdSettingsCloudControllerComputeThresholdsData, true>) =>
      sdk.thresholdSettingsCloudControllerComputeThresholds<true>(options).then((r) => r.data),
  },
  unit: {
    getMany: (options?: Options<T.UnitControllerGetManyData, true>) =>
      sdk.unitControllerGetMany<true>(options).then((r) => r.data),
  },
  usage: {
    getAccountingReport: (options: Options<T.UsageControllerGetAccountingReportData, true>) =>
      sdk.usageControllerGetAccountingReport<true>(options).then((r) => r.data),
    getAccountingReportDataForPdf: (options: Options<T.UsageControllerGetAccountingReportDataForPdfData, true>) =>
      sdk.usageControllerGetAccountingReportDataForPdf<true>(options).then((r) => r.data),
    getBillingReport: (options?: Options<T.UsageControllerGetBillingReportData, true>) =>
      sdk.usageControllerGetBillingReport<true>(options).then((r) => r.data),
    getCashRegisterJournalDataForPdf: (options: Options<T.UsageControllerGetCashRegisterJournalDataForPdfData, true>) =>
      sdk.usageControllerGetCashRegisterJournalDataForPdf<true>(options).then((r) => r.data),
    getDeliveriesByWholesaler: (options?: Options<T.UsageControllerGetDeliveriesByWholesalerData, true>) =>
      sdk.usageControllerGetDeliveriesByWholesaler<true>(options).then((r) => r.data),
    getExpensesReport: (options?: Options<T.UsageControllerGetExpensesReportData, true>) =>
      sdk.usageControllerGetExpensesReport<true>(options).then((r) => r.data),
    getExpensesReportData: (options?: Options<T.UsageControllerGetExpensesReportDataData, true>) =>
      sdk.usageControllerGetExpensesReportData<true>(options).then((r) => r.data),
    getProductsUnderControlSold: (options?: Options<T.UsageControllerGetProductsUnderControlSoldData, true>) =>
      sdk.usageControllerGetProductsUnderControlSold<true>(options).then((r) => r.data),
    getSalesByDay: (options?: Options<T.UsageControllerGetSalesByDayData, true>) =>
      sdk.usageControllerGetSalesByDay<true>(options).then((r) => r.data),
    getSalesBySeller: (options?: Options<T.UsageControllerGetSalesBySellerData, true>) =>
      sdk.usageControllerGetSalesBySeller<true>(options).then((r) => r.data),
    getSalesJournal: (options: Options<T.UsageControllerGetSalesJournalData, true>) =>
      sdk.usageControllerGetSalesJournal<true>(options).then((r) => r.data),
    getSalesReport: (options?: Options<T.UsageControllerGetSalesReportData, true>) =>
      sdk.usageControllerGetSalesReport<true>(options).then((r) => r.data),
    getSalesReportData: (options?: Options<T.UsageControllerGetSalesReportDataData, true>) =>
      sdk.usageControllerGetSalesReportData<true>(options).then((r) => r.data),
    getSalesUsage: (options?: Options<T.UsageControllerGetSalesUsageData, true>) =>
      sdk.usageControllerGetSalesUsage<true>(options).then((r) => r.data),
    getTopSales: (options?: Options<T.UsageControllerGetTopSalesData, true>) =>
      sdk.usageControllerGetTopSales<true>(options).then((r) => r.data),
    getTurnoverByCategory: (options?: Options<T.UsageControllerGetTurnoverByCategoryData, true>) =>
      sdk.usageControllerGetTurnoverByCategory<true>(options).then((r) => r.data),
    getTurnoverByStorage: (options?: Options<T.UsageControllerGetTurnoverByStorageData, true>) =>
      sdk.usageControllerGetTurnoverByStorage<true>(options).then((r) => r.data),
  },
  user: {
    create: (options: Options<T.UserControllerCreateData, true>) =>
      sdk.userControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.UserControllerDeleteData, true>) =>
      sdk.userControllerDelete<true>(options).then((r) => r.data),
    ensureValidator: (options: Options<T.UserControllerEnsureValidatorData, true>) =>
      sdk.userControllerEnsureValidator<true>(options).then((r) => r.data),
    get: (options: Options<T.UserControllerGetData, true>) => sdk.userControllerGet<true>(options).then((r) => r.data),
    getAll: (options?: Options<T.UserControllerGetAllData, true>) =>
      sdk.userControllerGetAll<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.UserControllerGetManyData, true>) =>
      sdk.userControllerGetMany<true>(options).then((r) => r.data),
    getMe: (options?: Options<T.UserControllerGetMeData, true>) =>
      sdk.userControllerGetMe<true>(options).then((r) => r.data),
    getMembers: (options?: Options<T.UserControllerGetMembersData, true>) =>
      sdk.userControllerGetMembers<true>(options).then((r) => r.data),
    update: (options: Options<T.UserControllerUpdateData, true>) =>
      sdk.userControllerUpdate<true>(options).then((r) => r.data),
  },
  wholesaler: {
    getMany: (options?: Options<T.WholesalerControllerGetManyData, true>) =>
      sdk.wholesalerControllerGetMany<true>(options).then((r) => r.data),
  },
  wholesalerBillStatement: {
    create: (options: Options<T.WholesalerBillStatementControllerCreateData, true>) =>
      sdk.wholesalerBillStatementControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.WholesalerBillStatementControllerDeleteData, true>) =>
      sdk.wholesalerBillStatementControllerDelete<true>(options).then((r) => r.data),
    getRecords: (options: Options<T.WholesalerBillStatementControllerGetRecordsData, true>) =>
      sdk.wholesalerBillStatementControllerGetRecords<true>(options).then((r) => r.data),
    getStatements: (options: Options<T.WholesalerBillStatementControllerGetStatementsData, true>) =>
      sdk.wholesalerBillStatementControllerGetStatements<true>(options).then((r) => r.data),
    getWholesalerBillStatementById: (
      options: Options<T.WholesalerBillStatementControllerGetWholesalerBillStatementByIdData, true>,
    ) => sdk.wholesalerBillStatementControllerGetWholesalerBillStatementById<true>(options).then((r) => r.data),
    updateWholesalerBillStatement: (
      options: Options<T.WholesalerBillStatementControllerUpdateWholesalerBillStatementData, true>,
    ) => sdk.wholesalerBillStatementControllerUpdateWholesalerBillStatement<true>(options).then((r) => r.data),
  },
  wholesalerClaim: {
    create: (options: Options<T.WholesalerClaimControllerCreateData, true>) =>
      sdk.wholesalerClaimControllerCreate<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.WholesalerClaimControllerGetManyData, true>) =>
      sdk.wholesalerClaimControllerGetMany<true>(options).then((r) => r.data),
    getOne: (options: Options<T.WholesalerClaimControllerGetOneData, true>) =>
      sdk.wholesalerClaimControllerGetOne<true>(options).then((r) => r.data),
    update: (options: Options<T.WholesalerClaimControllerUpdateData, true>) =>
      sdk.wholesalerClaimControllerUpdate<true>(options).then((r) => r.data),
  },
  wholesalerProduct: {
    create: (options: Options<T.WholesalerProductControllerCreateData, true>) =>
      sdk.wholesalerProductControllerCreate<true>(options).then((r) => r.data),
    delete: (options: Options<T.WholesalerProductControllerDeleteData, true>) =>
      sdk.wholesalerProductControllerDelete<true>(options).then((r) => r.data),
    getMany: (options?: Options<T.WholesalerProductControllerGetManyData, true>) =>
      sdk.wholesalerProductControllerGetMany<true>(options).then((r) => r.data),
  },
  wtw: {
    getWtwExport: (options?: Options<T.WtwControllerGetWtwExportData, true>) =>
      sdk.wtwControllerGetWtwExport<true>(options).then((r) => r.data),
  },
};
